<div class="row">
	<div class="col-6">
		@if(showApplicantTimeZone()){
		<div class="mb-3"> Applicant's TimeZone : <strong>{{applicantTimeZone()}}</strong></div>
		}
		<common-select-field [field]="timeZoneIdField()"></common-select-field>
	</div>
	<div class="col-5 offset-1">
		<p>Number of Meetings: <b>{{numMeetings()}}</b></p>
	</div>
</div>

<schedule-table-part [blockoutSlots]="blockoutSlots()" [selectedSlots]="selectedSlots()" [timeZoneId]="selectedTimeZoneId()"></schedule-table-part>